module.exports = __webpack_public_path__ + "img/dy_cover.8342cb75.png";